export default "__VITE_ASSET__X3AjliRt__"